var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLike20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.822 4C15.13 4 17 5.894 17 8.23c0 2.234-.841 3.366-4.435 6.197l-1.55 1.22c-.597.47-1.433.47-2.03 0l-1.55-1.22C3.841 11.597 3 10.464 3 8.23 3 5.894 4.87 4 7.178 4c.976 0 1.869.363 2.655 1.06l.167.155.167-.155C10.953 4.363 11.846 4 12.822 4z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjgyMjQgNEMxNS4xMjk2IDQgMTcgNS44OTM4NCAxNyA4LjIzMDAxQzE3IDEwLjQ2NCAxNi4xNTg4IDExLjU5NjMgMTIuNTY0OCAxNC40MjY3TDExLjAxNDcgMTUuNjQ3NUMxMC40MTc5IDE2LjExNzUgOS41ODIxMyAxNi4xMTc1IDguOTg1MjkgMTUuNjQ3NUw3LjQzNTE4IDE0LjQyNjdDMy44NDExNSAxMS41OTYzIDMgMTAuNDY0IDMgOC4yMzAwMUMzIDUuODkzODQgNC44NzAzOSA0IDcuMTc3NjMgNEM4LjE1NDE4IDQgOS4wNDY3MiA0LjM2MjYzIDkuODMzMTIgNS4wNjAzNkwxMCA1LjIxNDk5TDEwLjE2NjkgNS4wNjAzNkMxMC45NTMzIDQuMzYyNjMgMTEuODQ1OCA0IDEyLjgyMjQgNFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgLike20 as ReactComponent };